import React from "react";
import AdStudioLink from "widgets/actions/AdStudioLink";
import { LinkAction } from "widgets/ActionMenu";
import { shouldDisplayAction } from "utils/CreativeActions";
import { IMPOSIUM_URL } from "utils/constants";
import ImposiumLink from "widgets/actions/ImposiumAction";
import { transcodingChecks } from "utils/common";

export const EDIT_SOCIAL_CREATIVE = {
	shouldDisplay: ({ user }) => shouldDisplayAction.editSocialCreative(user),
	component: ({ dependentValues: { libraryId, creativeId } }) => {
		let actionProps = {
			key: "edit-social-creative",
			useMenuItem: true,
			className: "action-link action-item",
			iconName:"fas fa-pencil",
			path:`/library/${libraryId}/modal/edit-creative/social/${creativeId}/`,
			name: "Edit Creative",
		};

		return <LinkAction {...actionProps} />;
	},
};

export const OPEN_IN_AD_STUDIO = {
	shouldDisplay: ({ user, dependentValues }) => shouldDisplayAction.openInAdStudio(user, dependentValues),
	component: ({ dependentValues }) => {
		const { creativeId } = dependentValues;

		return (
			<AdStudioLink
				creativeId = {creativeId}
				iconOnly = { false }
			/>
		);
	},
};

export const OPEN_IN_IMPOSIUM = {
	shouldDisplay: ({ user, dependentValues }) => shouldDisplayAction.openInImposium(user, dependentValues),
	component: ({ dependentValues }) => {
		return (
			<ImposiumLink
				key="imposium"
				url={`${IMPOSIUM_URL}/${dependentValues?.storyId}?organization_id=${dependentValues?.organizationId}`}
				tooltipContent="Open in Imposium"
				isDisabled={transcodingChecks.transcoding(dependentValues)}
				iconOnly = { false }
			/>
		);
	},
};

export const EDIT_SOCIAL_ACTION_LIST = [
	[
		EDIT_SOCIAL_CREATIVE,
		OPEN_IN_AD_STUDIO,
		OPEN_IN_IMPOSIUM
	]
];
